import { render, staticRenderFns } from "./ProviderDetailsPage.vue?vue&type=template&id=7c2bab9c&scoped=true"
import script from "./ProviderDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProviderDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ProviderDetailsPage.vue?vue&type=style&index=0&id=7c2bab9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2bab9c",
  null
  
)

export default component.exports